import { render, staticRenderFns } from "./EntregaAnexos.vue?vue&type=template&id=6a470a96"
import script from "./EntregaAnexos.vue?vue&type=script&lang=js"
export * from "./EntregaAnexos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports